import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Creators as modalityActions } from '../../../../../domain/useCases/getModalityOfStudy';
import { Creators as planProgressResumeActions } from '../../../../../domain/useCases/getPlanProgressResume';
import AcademicInformationView from './AcademicInformationView';
import constants from '../../../courses/constants';
import ModuleContainer from '@/presentation/components/Container';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const AcademicInformationController: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [openDisclaimer, setOpenDisclaimer] = useState(false);

  const { isLoading: isLoadingPlanProgress, data: academicPlanProgress } =
    useSelector((state: any) => state.getPlanProgressResume);

  const { data: academic, isLoading: isLoadingAcademic } = useSelector(
    (state: any) => state.profile
  );

  const { isLoading: isLoadingModality, data: modality } = useSelector(
    (state: any) => state.modalityOfStudy
  );

  useEffect(() => {
    GoogleAnalytics.writeLog('portal-course-planProgressSummary', 'course');
    if (!modality) dispatch(modalityActions.getModalityOfStudy());
  }, []);

  useEffect(() => {
    if (academic?.academic?.plan) {
      dispatch(
        planProgressResumeActions.getPlanProgressResume(
          academic.academic.plan,
          academic.academic.prog
        )
      );
    }
  }, [academic]);

  const handlerBack = useMemo(() => () => history.push('/cursos'), [history]);

  const isProcessingAcademicPlanProgress = useMemo(
    () => isLoadingPlanProgress || isLoadingAcademic || isLoadingModality,
    [isLoadingPlanProgress, isLoadingAcademic, isLoadingModality]
  );

  return (
    <ModuleContainer containerType="subsection">
      <AcademicInformationView
        disclaimer={{
          openDisclaimer,
          setOpenDisclaimer
        }}
        academic={academic?.academic}
        modality={modality}
        academicPlanProgress={academicPlanProgress}
        isProcessingAcademicPlanProgress={isProcessingAcademicPlanProgress}
        subsectionHeader={constants.subsectionHeader}
        handlerBack={handlerBack}
      />
    </ModuleContainer>
  );
};

export default AcademicInformationController;
